__turbopack_context__.v({
  "container": "search_card-module-scss-module__jybFvW__container",
  "containerContent": "search_card-module-scss-module__jybFvW__containerContent",
  "containerImage": "search_card-module-scss-module__jybFvW__containerImage",
  "containerMask": "search_card-module-scss-module__jybFvW__containerMask",
  "contentStats": "search_card-module-scss-module__jybFvW__contentStats",
  "contentTitle": "search_card-module-scss-module__jybFvW__contentTitle",
  "maskButton": "search_card-module-scss-module__jybFvW__maskButton",
  "statsItem": "search_card-module-scss-module__jybFvW__statsItem",
});
